import axios from "axios";
import Config from "../utils/Config";

class NotificationService {
  config = {
    headers: {
      Authorization: "",
      GroupId: "",
      CompanyId: "",
    },
  };

  setAccessToken(accessToken, groupId, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.GroupId = groupId;
    this.config.headers.CompanyId = companyId;
  }

  /**
   * Send trading partner error email with uploaded Excel file as base64 attachment
   * @param {string} accessToken - Auth token
   * @param {string} groupId - Group ID
   * @param {string} companyId - Company ID
   * @param {object} payload - { fileName, fileBase64, errorLogFileName?, errorLogFileBase64? }
   */
  async sendTradingPartnerErrorEmail(accessToken, groupId, companyId, payload) {
    this.setAccessToken(accessToken, groupId, companyId);

    const body = {
      companyId,
      groupId,
      fileName: payload.fileName,
      fileBase64: payload.fileBase64,
    };
    if (payload.errorLogFileBase64) {
      body.errorLogFileName = payload.errorLogFileName || "Trading_Partner_Error_Log.xlsx";
      body.errorLogFileBase64 = payload.errorLogFileBase64;
    }

    const data = await axios.post(
      Config.BACKEND_URL + "/api/notification/trading-partner-error",
      body,
      this.config
    );
    return data.data;
  }
}

export default new NotificationService();
